var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14C2.5 20.6274 7.87258 26 14.5 26C21.1274 26 26.5 20.6274 26.5 14C26.5 7.37258 21.1274 2 14.5 2C7.87258 2 2.5 7.37258 2.5 14ZM15.75 8C15.75 8.69036 15.1904 9.25 14.5 9.25C13.8096 9.25 13.25 8.69036 13.25 8C13.25 7.30964 13.8096 6.75 14.5 6.75C15.1904 6.75 15.75 7.30964 15.75 8ZM14.5 11C15.0523 11 15.5 11.4477 15.5 12L15.5 20C15.5 20.5523 15.0523 21 14.5 21C13.9477 21 13.5 20.5523 13.5 20L13.5 12C13.5 11.4477 13.9477 11 14.5 11Z",
    fill: "#64CFE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBlueIcon);
export default __webpack_public_path__ + "static/media/alert_blue_icon.d34abd5b3910d83ed8b8d37ab1150e33.svg";
export { ForwardRef as ReactComponent };